module.exports = __webpack_public_path__ + "static/img/feature_2.f556522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/feature_2.png
// module id = Xlhm
// module chunks = 0